import React, { useRef, useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import $ from 'jquery';
import axios from 'axios';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import { Tooltip, OverlayTrigger } from 'react-bootstrap'; 
import break_box from '../../../../images/product/break_box.png';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css'; 
import { Link } from "react-router-dom"; 

const ViewMenuMaker = ({ show, onClose, selectedSno }) => {
    const onInit = () => {
        //   console.log('lightGallery has been initialized');
    };
     const [menuData, setMenuData] = useState({});
  const [productInfo, setProductInfo] = useState(null);
  const [productImage, setProductImage] = useState(null);

  useEffect(() => {
    if (!show || !selectedSno) return;

    const fetchData = async () => {
      try {
        const res = await axios.get(`${baseURL}/menumaker/${selectedSno}`);
        const data = res.data?.data || {};
        setMenuData(data);

        if (data.products && data.products.length > 0) {
          const product = data.products[0];
          setProductInfo({
            product_name: product.product_name,
            productcategory_name: data.productcategory_name,
          });
          setProductImage(product.product_image || null);
        }
      } catch (error) {
        console.error('Failed to fetch menu data:', error);
      }
    };

    fetchData();
  }, [show, selectedSno]);

  const formatDateDay = () => {
    if (!menuData?.menu_maker_date) return '';
    const date = new Date(menuData.menu_maker_date);
    const options = { weekday: 'long', year: 'numeric', month: 'short', day: 'numeric' };
    return date.toLocaleDateString(undefined, options);
  };

  // const [menuData, setMenuData] = useState(null);
  const tableRef = useRef(null);
  const baseURL = process.env.REACT_APP_API_BASE_URL;

  // Fetch menu data
  // useEffect(() => {
  //   if (show && selectedSno) {
  //     axios
  //       .get(`${baseURL}/menumaker/${selectedSno}`)
  //       .then((res) => {
  //         setMenuData(res.data.data || {});  
  //       })
  //       .catch(console.error);
  //   }
  // }, [selectedSno, show, baseURL]);

  // Setup DataTable
  useEffect(() => {
    if (tableRef.current && menuData?.products?.length > 0) {
      const $table = $(tableRef.current);

      if ($.fn.dataTable.isDataTable($table)) {
        $table.DataTable().destroy();
      }

      setTimeout(() => {
        $table.DataTable({
          responsive: true,
          ordering: false,
          paging: false,
          scrollCollapse: true,
          language: { lengthMenu: 'Show _MENU_' },
          dom:
            "<'row'" +
            "<'col-sm-12 d-flex align-items-center justify-content-end mb-2'f>" +
            ">" +
            "<'table-responsive'tr>" +
            "<'row'" +
            "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
            ">"
        });
      }, 0);
    }
  }, [menuData]);

  // Render table rows
  const renderRows = () => {
    if (!menuData || !menuData.products) return null;

    const itemsMap = {};

    menuData.products.forEach((product) => {
      product.items.forEach((item) => {
        const key = item.item_name;
        if (!itemsMap[key]) itemsMap[key] = {};

        const existing = itemsMap[key][product.product_name];
        if (existing) {
          existing.quantity += item.quantity;
        } else {
          itemsMap[key][product.product_name] = {
            quantity: item.quantity,
            unit: item.measurement_unit
          };
        }
      });
    });

    return Object.entries(itemsMap).map(([itemName, productData], idx) => (
      <tr key={idx}>
        <td><label className='text-black font-w400 fs-7'>{itemName}</label></td>
        {menuData.products.map((product, pi) => {
          const data = productData[product.product_name];
          return (
            <td key={pi}>
              <label className='text-black font-w400 fs-7'>
                {data ? (
                  <>
                    <span className='me-2'>{data.quantity.toString().padStart(2, '0')}</span>
                    <span>{data.unit}</span>
                  </>
                ) : (
                  <span className='text-muted'>--</span>
                )}
              </label>
            </td>
          );
        })}
      </tr>
    ));
  };

  // Determine scroll behavior
  const hasVerticalScroll = menuData?.products?.[0]?.items?.length > 7;
  const hasHorizontalScroll = menuData?.products?.length > 3;

  // return (
  //   <Modal show={show} size="lg">
  //     <div className="modal-content">
  //       <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
  //         <h3 className="modal-title text-white">View Menu Quantity</h3>
  //         <Button variant="" type="button" className="close px-6 py-1" onClick={onClose}>
  //           <span className="text-white">×</span>
  //         </Button>
  //       </div>

  //       <div
  //         className="modal-body"
  //         style={{
  //           overflowX: hasHorizontalScroll ? 'hidden' : 'auto',
  //         }}
  //       >

  //         <div className="row">
  //           <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
  //               <label className='text-gray-800 font-w500 fs-7'>Product Category</label>
  //               <label className='text-danger fs-6 font-w500'>{productInfo?.productcategory_name}</label>
  //           </div>
  //           <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
  //               <div className='d-flex flex-row gap-3 align-items-center justify-content-center'>
  //                   <LightGallery
  //                       onInit={onInit}
  //                       speed={500}
  //                       plugins={[lgThumbnail, lgZoom]} 
  //                   >
  //                       <div data-src={productImage || break_box} className='border rounded px-1 py-0'>
  //                           <img src={productImage || break_box} className='cursor-pointer w-45px h-45px' />
  //                       </div>
  //                   </LightGallery>
  //                   <div className='d-flex flex-column'>
  //                       <label className='text-gray-800 font-w500 fs-7'>Product</label>
  //                       <label className='text-danger fs-6 font-w500'>{productInfo?.product_name}</label>
  //                   </div>
  //               </div>
  //           </div>
  //           <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
  //               <label className='text-gray-800 font-w500 fs-7'>Date & Day</label>
  //               <label className='text-danger fs-6 font-w500'>{formatDateDay()}</label>
  //           </div>
  //         </div>

  //         <div
  //           className="table-container"
  //           style={{
  //             maxHeight: hasVerticalScroll ? '400px' : 'unset',
  //             overflowY: hasVerticalScroll ? 'auto' : 'unset',
  //            }}
  //         >
  //           <table
  //             ref={tableRef}
  //             className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable"
  //             // style={{
  //             //   minWidth: hasHorizontalScroll ? '800px' : '100%',
  //             // }}
  //           >
  //             <thead>
  //               <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
  //                 <th className='min-w-100px text-start'>Items</th>
  //                 {menuData?.products?.map((p, i) => (
  //                   <th key={i} className='min-w-100px'>Qty/Unit</th> //{p.product_name}
  //                 ))}
  //               </tr>
  //             </thead>
  //             <tbody className="text-gray-600 fw-semibold fs-7">
  //               {renderRows()}
  //             </tbody>
  //           </table>
  //         </div>
  //       </div>
  //     </div>
  //   </Modal>
  // );

 return (
  <Modal show={show} size="lg">
    <div className="modal-content">
      <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
        <h3 className="modal-title text-white">View Menu Quantity</h3>
        <Button variant="" type="button" className="close px-6 py-1" onClick={onClose}>
          <span className="text-white">×</span>
        </Button>
      </div>

      <div
        className="modal-body"
        style={{
          overflowX: 'hidden',
          overflowY: 'auto',
        }}
      >
        <div className="row">
          <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
            <label className='text-gray-800 font-w500 fs-7'>Product Category</label>
            <label className='text-danger fs-6 font-w500'>{productInfo?.productcategory_name}</label>
          </div>
          <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
            <div className='d-flex flex-row gap-3 align-items-center justify-content-center'>
              <LightGallery
                onInit={onInit}
                speed={500}
                plugins={[lgThumbnail, lgZoom]}
              >
                <div data-src={productImage || break_box} className='border rounded px-1 py-0'>
                  <img src={productImage || break_box} className='cursor-pointer w-45px h-45px' />
                </div>
              </LightGallery>
              <div className='d-flex flex-column'>
                <label className='text-gray-800 font-w500 fs-7'>Product</label>
                <label className='text-danger fs-6 font-w500'>{productInfo?.product_name}</label>
              </div>
            </div>
          </div>
          <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
            <label className='text-gray-800 font-w500 fs-7'>Date & Day</label>
            <label className='text-danger fs-6 font-w500'>{formatDateDay()}</label>
          </div>
        </div>

        <div
          className="table-container"
          // style={{
          //   overflowX: 'hidden',
          //   overflowY: 'auto',
          // }}
        >
          {/* <table
            ref={tableRef}
            className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable"
            style={{
              minHeight: '50px',
            }}
          >
            <thead>
              <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                <th className='min-w-100px text-start'>Items</th>
                {menuData?.products?.map((p, i) => (
                  <th key={i} className='min-w-100px'>Qty/Unit</th> // {p.product_name}
                ))}
              </tr>
            </thead>
            <tbody className="text-gray-600 fw-semibold fs-7">
              {renderRows()}
            </tbody>
          </table> */}
<div
  style={{
    maxHeight: '300px',
    overflowY: 'auto',
    overflowX: 'hidden', // ⛔ explicitly block horizontal scroll
  }}
>
  <table
    ref={tableRef}
    className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable"
    style={{
      minHeight: '100px',
      width: '100%',        // Full width inside container
      tableLayout: 'fixed', // Prevent extra expansion
    }}
  >
    <thead>
      <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
        <th className="min-w-100px text-start">Items</th>
        {menuData?.products?.map((p, i) => (
          <th key={i}>Qty/Unit</th>
        ))}
      </tr>
    </thead>
    <tbody className="text-gray-600 fw-semibold fs-7">
      {renderRows()}
    </tbody>
  </table>
</div>


        </div>
      </div>
    </div>
  </Modal>
);



};

export default ViewMenuMaker;
